// API Configuration
declare global {
  interface Window {
    mqVueData?: {
      ajaxUrl: string;
      nonce: string;
      siteUrl: string;
      salesforceApiUrl?: string;
      restUrl: string;
      userId: number;
    };
  }
}

// Get the API domain with Salesforce API URL support
export const API_DOMAIN = (() => {
  // First try to get from window.mqVueData
  if (typeof window !== 'undefined' && window.mqVueData?.siteUrl) {
    return window.mqVueData.siteUrl
  }
  
  // Fallback to current origin
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
  
  // Server-side fallback
  return 'http://localhost'
})()

// Get Salesforce API URL from WordPress ACF options
export const getSalesforceApiUrl = (): string => {
  // Try to get from window.mqVueData first
  if (typeof window !== 'undefined' && window.mqVueData?.salesforceApiUrl) {
    console.log('🔍 Using Salesforce API URL from mqVueData:', window.mqVueData.salesforceApiUrl)
    return window.mqVueData.salesforceApiUrl
  }
  
  // Log what we have available
  if (typeof window !== 'undefined') {
    console.log('🔍 mqVueData available:', !!window.mqVueData)
    console.log('🔍 mqVueData.salesforceApiUrl:', window.mqVueData?.salesforceApiUrl)
    console.log('🔍 API_DOMAIN fallback:', API_DOMAIN)
  }
  
  // Fallback to WordPress site URL
  console.warn('⚠️ Salesforce API URL not found, using WordPress URL as fallback')
  return API_DOMAIN
}

// API endpoints
export const API_ENDPOINTS = {
  // WordPress REST API endpoints (use WordPress site URL)
  CATEGORIES: '/wp-json/wc/v3/sf_templates',
  COURSES: '/wp-json/wc/v3/sf_template',
  PRODUCTS: '/wp-json/wc/v3/product',
  COURSE_MOMENTS: '/wp-json/wc/v3/course_moments',
  COURSE_IN_CART: '/wp-json/wc/v3/course_in_cart',
  PRODUCT_PRICE: '/wp-json/wc/v3/product_price',
  
  // Salesforce API endpoints (use Salesforce API URL)
  SALESFORCE_COURSES: '/services/apexrest/Courses',
  SALESFORCE_PRODUCTS: '/services/apexrest/Products',
  SALESFORCE_ORDERS: '/services/apexrest/Orders',
  SALESFORCE_BOOKINGS: '/services/apexrest/Bookings'
}

// Helper function to build WordPress REST API URLs
export const buildApiUrl = (endpoint: string, baseUrl?: string): string => {
  const base = baseUrl || API_DOMAIN
  return `${base}${endpoint}`
}

// Helper function to build Salesforce API URLs
export const buildSalesforceApiUrl = (endpoint: string): string => {
  const salesforceBase = getSalesforceApiUrl()
  return `${salesforceBase}${endpoint}`
}

// Helper function to determine which API to use based on endpoint
export const buildSmartApiUrl = (endpoint: string): string => {
  // Check if this is a Salesforce endpoint
  const salesforceEndpoints = [
    API_ENDPOINTS.SALESFORCE_COURSES,
    API_ENDPOINTS.SALESFORCE_PRODUCTS,
    API_ENDPOINTS.SALESFORCE_ORDERS,
    API_ENDPOINTS.SALESFORCE_BOOKINGS
  ]
  
  if (salesforceEndpoints.includes(endpoint)) {
    return buildSalesforceApiUrl(endpoint)
  }
  
  // Default to WordPress REST API
  return buildApiUrl(endpoint)
} 